/* eslint-disable no-unused-vars */
const Types = require('../../../../jsdoc-types');
const checkoutStageConstants = require('./stage/constants');
/* eslint-enable no-unused-vars */

const { generateSingletonExports } = require('../common/utils/singleton');

const EVENTS = {
  /**
   * Event triggered when the Chekout stage is changed
   * @param {Object} payload The payload of the event
   * @param {checkoutStageConstants} payload.currentStage The current stage after the change
   */
  checkoutStageChanged: 'checkout-stage:changed',
};

const PAYLOADS = {};

/**
 * The Checkout Events' Information
 * @readonly
 * @enum {string}
 */
const CHECKOUT_EVENTS = {
  ...EVENTS,
  PAYLOADS,
};

const { createEventBus } = require('../common/utils/eventBus');

const checkoutEventBus = createEventBus('checkout', {
  events: EVENTS,
  payloads: PAYLOADS,
});

const exported = {
  CHECKOUT_EVENTS,
  checkoutEventBus,
};

/** @type {exported} */
module.exports = generateSingletonExports('checkout-events', exported);
